var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowYaxis(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 93,
    height: 8,
    viewBox: "0 0 93 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M92.3536 4.35355C92.5488 4.15829 92.5488 3.84171 92.3536 3.64645L89.1716 0.464466C88.9763 0.269204 88.6597 0.269204 88.4645 0.464466C88.2692 0.659728 88.2692 0.976311 88.4645 1.17157L91.2929 4L88.4645 6.82843C88.2692 7.02369 88.2692 7.34027 88.4645 7.53553C88.6597 7.7308 88.9763 7.7308 89.1716 7.53553L92.3536 4.35355ZM0 4.5L92 4.5V3.5L0 3.5L0 4.5Z",
    fill: "#353536"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowYaxis);
export default __webpack_public_path__ + "static/media/arrow-yaxis.415c4d39f16074ea65bfda5be9c7693b.svg";
export { ForwardRef as ReactComponent };